var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuandoo = function SvgQuandoo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quandoo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.427 24.531c-.925-1.116-1.993-2.968-2.42-4.24-3.49 0-7.738-2.657-7.738-7.903 0-4.42 2.777-7.857 7.737-7.857 4.723 0 7.761 3.773 7.761 7.947 0 4.263-2.8 6.92-4.841 6.92 0 0 1.542 3.638 4.913 6.25 1.471 1.138 5.126 3.615 8.544 4.352l.617-.781c-4.343-1.63-7.547-4.152-7.547-6.474 0-1.361.38-2.053 1.163-3.125 1.613-2.165 2.373-4.62 2.373-7.03C25.989 5.401 20.127 0 12.935 0 6.005 0 0 5.402 0 12.41c0 7.3 6.907 13.617 15.427 12.121Z",
    fill: "#F8B333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quandoo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgQuandoo;